var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("RL 3.1 Indikator Pelayanan")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("ul", { staticClass: "nav nav-tabs mb-3", attrs: { role: "tablist" } }, [
      _c("li", { staticClass: "nav-item", attrs: { role: "presentation" } }, [
        _c(
          "button",
          {
            staticClass: "nav-link",
            class: { active: _vm.activeTab === "detail" },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.activeTab = "detail"
              },
            },
          },
          [_vm._v("\n                Detail\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "nav-item", attrs: { role: "presentation" } }, [
        _c(
          "button",
          {
            staticClass: "nav-link",
            class: { active: _vm.activeTab === "rekap" },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.activeTab = "rekap"
              },
            },
          },
          [_vm._v("\n                Rekap\n            ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tab-content" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "detail",
              expression: "activeTab === 'detail'",
            },
          ],
        },
        [
          _c("DataTable", {
            attrs: {
              "table-id": "table-indikator-detail",
              title: "Indikator Pelayanan - Detail",
              "filter-configs": _vm.filterConfigs,
              "table-options": _vm.tableOptionsDetail,
              "show-filter": true,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "rekap",
              expression: "activeTab === 'rekap'",
            },
          ],
        },
        [
          _c("DataTable", {
            attrs: {
              "table-id": "table-indikator-rekap",
              title: "Indikator Pelayanan - Rekap",
              "filter-configs": _vm.filterConfigs,
              "table-options": _vm.tableOptionsRekap,
              "show-filter": true,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }